import { FC, useEffect, useState } from 'react';
import { format } from "date-fns";
import { APP } from "../../Utils/Constants.ts";

interface DateRangeProps {
  value?: any;
  handleDate: (filterId: string, value: any) => void;
}

const toInputValue = (date?: Date): string => date ? format(date, "yyyy-MM-dd") : '';

const fromInputValue = (value: string): Date | undefined => value ? new Date(value) : undefined;

const DateRange: FC<DateRangeProps> = ({ handleDate, value }) => {

  const getDefaultValue = (type: 'start' | 'end'): Date | undefined => {
    if (!value) return;

    if (type === 'start') {
      return value.values?.[0] ? new Date(value.values[0]) : undefined;
    }

    if (type === 'end') {
      return value.values?.[1] ? new Date(value.values[1]) : undefined;
    }
  };

  const [startDate, setStartDate] = useState<Date | undefined>(getDefaultValue('start'));
  const [endDate, setEndDate] = useState<Date | undefined>(getDefaultValue('end'));
  const [dateValues, setDateValues] = useState<any>([startDate, endDate]);
  const [userHasChangedDates, setUserHasChangedDates] = useState(false);

  const convertDate = (dates: Date[]) => {
    if (!Array.isArray(dates)) return;
    return dates.map(d => d ? format(d, "yyyy-MM-dd") : undefined);
  };

  useEffect(() => {
    if (dateValues[0] !== undefined && userHasChangedDates) {
      handleDate(APP.FILTER.STARTDATE.FIELD, convertDate(dateValues));
      setUserHasChangedDates(false);
    }
  }, [dateValues]);

  useEffect(() => {
    if (endDate && !startDate) {
      const now = new Date();
      setStartDate(now);
      setDateValues([now, endDate]);
    } else {
      setDateValues([startDate, endDate]);
    }
  }, [startDate, endDate]);

  return (
    <div className="filter-wrapper daterange-input">

      {/* START DATE */}
      <label htmlFor="start-date">
        Du<span className="visually-hidden"> (format JJ/MM/AAAA)</span>
      </label>

      <input
        id="start-date"
        type="date"
        lang="fr"
        value={toInputValue(startDate)}
        onChange={(e) => {
          setStartDate(fromInputValue(e.target.value));
          setUserHasChangedDates(true);
        }}
      />

      {/* END DATE */}
      <label htmlFor="end-date">
        au<span className="visually-hidden"> (format JJ/MM/AAAA)</span>
      </label>

      <input
        id="end-date"
        type="date"
        lang="fr"
        value={toInputValue(endDate)}
        onChange={(e) => {
          setEndDate(fromInputValue(e.target.value));
          setUserHasChangedDates(true);
        }}
      />

    </div>
  );
};

export default DateRange;
